import React, { useContext, useState, useEffect } from 'react'
import { Row, Col, Form, Button } from 'react-bootstrap'
import { LanguageContext } from '../Language/LanguageContext'
import { HeaderTitle, NotifyContext, Loading, Checkbox } from '../Library'
import { createPackage, viewPackage, editPackage } from '../Network/Administration'
import { useHistory, useParams } from 'react-router-dom'
import { LITERAL_TYPES } from '@babel/types'

function EditPackage() {
    const { id } = useParams()
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.administration
    const notify = useContext(NotifyContext)
    const history = useHistory()

    const [packageName, setPackageName] = useState("")
    const [packageDetail, setPackageDetail] = useState("")
    const [isError, setError] = useState(false)
    const [isLoading, setLoading] = useState(false)
    const [limitUser, setLimitUser] = useState(1)
    const [isUnlimitedUser, setIsUnlimitedUser] = useState(false)
    const [limitTenants, setLimitTenants] = useState(1)
    const [isUnlimitedTenants, setIsUnlimitedTenants] = useState(false)

    const infoNotComplete = () =>{
        notify.showNotify(lang.not_complete, lang.not_complete_desc, 1)
        setError(true)
    }

    const submit = () =>{
        if(!packageName || !packageDetail){
            infoNotComplete()
            return
        }
        if(!isUnlimitedUser && !limitUser){
            infoNotComplete()
            return
        }

        if(!isUnlimitedTenants && !limitTenants){
            infoNotComplete()
            return
        }

        setLoading(true)

        var luser = limitUser
        var ltenant = limitTenants
        if(isUnlimitedUser){
            luser = 0
        }
        if(isUnlimitedTenants){
            ltenant = 0
        }

        editPackage(id, packageName, packageDetail, luser, ltenant,
            ()=>{
                setLoading(false)
                notify.showNotify(lang.edited_package, lang.edited_package_desc, 0)
                history.push("/package")
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            })
    }

    const fetchData = () =>{
        setLoading(true)
        viewPackage(id,
            (packageInfo, features)=>{
                setPackageName(packageInfo.packageName)
                setPackageDetail(packageInfo.packageDetail)

                if(packageInfo.limitUser === 0){
                    setIsUnlimitedUser(true)
                }else{
                    setLimitUser(packageInfo.limitUser)
                }

                if(packageInfo.limitTenants === 0){
                    setIsUnlimitedTenants(true)
                }else{
                    setLimitTenants(packageInfo.limitTenants)
                }

                setLoading(false)
            },
            (error)=>{
                notify.showNotify("Something wrong", error.message, 2)
                setLoading(false)
            })
    }

    useEffect(()=>{
        fetchData()
    },[])

    return (
        <div id="edit-package">
            { isLoading ? <Loading/> : null }
            <HeaderTitle title={lang.edit_package} isShowBack backTo="/package"/>
            <Row>
                <Col md={10} lg={8} xl={6}>
                    <Form
                    onSubmit={(e)=>{
                        e.preventDefault()
                        submit()
                    }}
                    >
                        <Form.Group>
                            <Form.Label>{lang.package_name}</Form.Label>
                            <Form.Control
                            value={packageName}
                            onChange={(e)=>setPackageName(e.target.value)}
                            isInvalid={isError && !packageName}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.package_detail}</Form.Label>
                            <Form.Control 
                            as="textarea"
                            value={packageDetail}
                            onChange={(e)=>setPackageDetail(e.target.value)}
                            isInvalid={isError && !packageDetail}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.maximum_user}</Form.Label>
                            <Form.Control
                            type="number"
                            min={1}
                            disabled={isUnlimitedUser}
                            value={limitUser}
                            isInvalid={isError && !limitUser && !isUnlimitedUser}
                            onChange={(e)=>setLimitUser(e.target.value)}
                            />
                            <Checkbox 
                            label={lang.unlimited_user}
                            checked={isUnlimitedUser}
                            onChange={()=>setIsUnlimitedUser(!isUnlimitedUser ? true : false)}
                            style={{ marginTop: 10 }}/>
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{lang.maximum_tenants}</Form.Label>
                            <Form.Control
                            type="number"
                            min={1}
                            disabled={isUnlimitedTenants}
                            isInvalid={isError && !limitTenants && !isUnlimitedTenants}
                            value={limitTenants}
                            onChange={(e)=>setLimitTenants(e.target.value)}
                            />
                            <Checkbox 
                            label={lang.unlimited_tenants} 
                            checked={isUnlimitedTenants}
                            onChange={()=>setIsUnlimitedTenants(!isUnlimitedTenants ? true : false)}
                            style={{ marginTop: 10 }}/>
                        </Form.Group>
                        <hr/>
                        <Button type="submit">
                            {lang.save_change}
                        </Button>
                    </Form>
                </Col>
            </Row>
        </div>
    )
}

export default EditPackage
